export function getCurrencyCode() {
  if (typeof window === 'undefined') return 'INR';
  return window.location.hostname.includes('.ae') ? 'AED' : 'INR';
}

export function formatMoney(amount: unknown) {
  const num = Number(String(amount ?? 0).replace(/[^\d.-]/g, ''));
  const safe = Number.isFinite(num) ? num : 0;
  const code = getCurrencyCode();
  const locale = code === 'AED' ? 'en-AE' : 'en-IN';
  return `${code} ${safe.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatCount(value: unknown) {
  const num = Number(value ?? 0);
  const safe = Number.isFinite(num) ? num : 0;
  const locale = getCurrencyCode() === 'AED' ? 'en-AE' : 'en-IN';
  return safe.toLocaleString(locale);
}

export function formatCompactMoney(amount: unknown) {
  const num = Number(String(amount ?? 0).replace(/[^\d.-]/g, ''));
  const safe = Number.isFinite(num) ? num : 0;
  const code = getCurrencyCode();
  const locale = code === 'AED' ? 'en-AE' : 'en-IN';
  const compact = new Intl.NumberFormat(locale, {
    notation: 'compact',
    maximumFractionDigits: 2,
  }).format(safe);
  return `${code === 'INR' ? 'INR ' : code + ' '}${compact}`;
}


export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}